import { DisciplineEvaluationAndDeadlines } from '@/models/evaluation-and-deadlines/evaluation-and-deadlines.model';
import { ActiveStudyWindow } from '@/services/undergrad/pegasus-pepe-legal/user-grades.service';
import RootState from '@/store/root_state';
import { GetterTree } from 'vuex';
import { AssessmentState } from './state';

const getters: GetterTree<AssessmentState, RootState> = {
  activeStudyWindows: (state): ActiveStudyWindow[] | undefined => {
    return state.activeStudyWindows;
  },
  getActiveStudyWindow:
    (state) =>
    (studyWindowId: string): ActiveStudyWindow | null => {
      if (!state.activeStudyWindows) return null;

      const foundStudyWindow = state.activeStudyWindows.find(
        (studyWindow) => studyWindow.id === studyWindowId,
      );

      return foundStudyWindow || null;
    },
  getCurrentStudyWindow: (state): ActiveStudyWindow | null => {
    if (!state.activeStudyWindows) return null;

    const studyWindowRunning = state.activeStudyWindows.find(
      (studyWindow) => studyWindow.isRunning,
    );

    return studyWindowRunning || null;
  },
  getEvaluationAndDeadlines: (state): DisciplineEvaluationAndDeadlines[] | null => {
    if (!state.evaluationAndDeadlines) return null;

    return state.evaluationAndDeadlines;
  },
};

export default getters;
